export enum ModuleType {
    modulo_singolo = 1,
    modulo_doppio_larghezza = 2,
    modulo_doppio_profondità = 3,
}
export enum InstallationType {
    installazione_libera = 75,
    addossata_profondita = 76,
    addossata_larghezza = 77,
    patio = 78,
    angolare = 79,
    nuove_conf = 99,
}
export enum LatoInstallation {
    libero = 0,
    addossato = 1,
    con_muretto = 2
}
export interface ClosuresApiResponse {
  success: boolean;
  message: string | null;
  data: Array<{
    sku: string;
    qty: number;
    um: string;
    name: string;
    net: number;
    price: number;
    additionalData: string;
  }>;
}